import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApp } from '../../context/AppContext';

import { sendGTMEvent } from '../../utils/analytics';
import { GA4_KEY, ROUTES } from '../../utils/constants';

import CachedImage from '../../components/CachedImage/CachedImage';

import { colors } from '../../styles/colors';
import styles from './Communitis.module.css';

const Communities = () => {
  const { appDescription, telegram } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    telegram.BackButton.show();
    telegram.setHeaderColor(colors.background.main);
    telegram.BackButton.onClick(() => {
      telegram.HapticFeedback.impactOccurred('medium');
      navigate(ROUTES.home);
    });
    sendGTMEvent(GA4_KEY.navigate(window.location.href));

    return () => {
      telegram.BackButton.onClick = () => {};
      telegram.setHeaderColor(colors.background.backend);
      telegram.BackButton.hide();
    };
    // eslint-disable-next-line
  }, [navigate]);

  return (
    <div className={styles.paidChatsModal}>
      <div className={styles.chatList}>
        {appDescription?.communities?.map(chat => (
          <div
            key={chat.id}
            className={styles.chatItem}
          >
            <CachedImage
              src={chat.image || appDescription?.avatar}
              alt={chat.name}
              className={styles.chatIcon}
            />
            <div className={styles.chatInfo}>
              <div className={styles.chatName}>{chat.name}</div>
              <div className={styles.chatDescription}>{chat.description}</div>
              <div className={styles.chatPrice}>{chat.free ? 'FREE' : 'PAID'}</div>
            </div>
            <button
              className={styles.joinButton}
              onClick={() => {
                sendGTMEvent(GA4_KEY.open_channel(chat.name, chat.price));
                if (chat.link.startsWith('https://t.me/') || chat.link.startsWith('https://telegram.me/')) {
                  telegram.openTelegramLink(chat.link);
                } else {
                  window.open(chat.link, '_blank');
                }
                telegram.HapticFeedback.impactOccurred('light');
              }}
            >
              {appDescription?.subscription_button ? (chat.free ? 'Присоединиться' : 'Купить') : 'Перейти'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Communities;
